import { render, staticRenderFns } from "./EmployeeCreateForm.vue?vue&type=template&id=65c46f91&"
import script from "./EmployeeCreateForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports